import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { supportedLngs } from "./config";
import translation from "../locales/fr/translation.json";

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: { fr: { translation } },
        supportedLngs: Object.keys(supportedLngs),
        fallbackLng: "fr"
    });

export default i18n;
